// @flow

import type { StrengthType } from './types';

export const NONE: StrengthType = 'NONE';
export const STRONG: StrengthType = 'STRONG';
export const MEDIUM: StrengthType = 'MEDIUM';
export const WEAK: StrengthType = 'WEAK';
